import PropTypes from 'prop-types';

function RoundButtonWeb({ icon, onClick, focused, onMouseEnter, onMouseLeave }) {
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      style={{
        width: "36px",
        height: "36px",
        backgroundColor: focused ? "rgba(255, 255, 255, 0.15)" : "rgba(255, 255, 255, 0.1)",
        border: `1px solid ${focused ? "rgba(255, 255, 255, 0.5)" : "rgba(255, 255, 255, 0.2)"}`,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        color: "#ffffff",
        fontSize: "18px",
        transform: focused ? "scale(1.05)" : "scale(1)"
      }}
    >
      {icon && (
        <span className="material-symbols-outlined">
          {icon}
        </span>
      )}
    </div>
  );
}

RoundButtonWeb.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  focused: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};

export default RoundButtonWeb;
